<div class=" w-full flex flex-col relative">
  <div class="md:mx-5 md:mt-10 mt-5">
    <div class="flex flex-col justify-center mb-2 mx-5">
      <div class="text-start">
        <p class=" md:text-4xl text-2xl text-primary font-bold ">
          <span class="border-b border-gray-300 inline-block">{{title}} </span>
        </p>
      </div>
    </div>
    <div class="relative flex flex-wrap md:p-2 justify-center  md:py-2">
      <!-- <button class="absolute h-full align-middle left-0 z-10 p-2 text-4xl rounded-r hidden md:block"
        (click)="scrollLeft(scrollContainer)">❮</button>
      <button class="absolute h-full align-middle right-0 z-10 text-4xl p-2 rounded-l hidden md:block"
        (click)="scrollRight(scrollContainer)">❯</button> -->
      <div class=" flex flex-wrap mx-5">
        <div class="grid grid-cols-2 md:flex md:flex-wrap gap-5">
          <div class="skeleton-loader" *ngIf="!cardLoaded">
          </div>
          <div class="skeleton-loader" *ngIf="!cardLoaded">
          </div>
          <div class="skeleton-loader" *ngIf="!cardLoaded">
          </div>
          <div class="skeleton-loader" *ngIf="!cardLoaded">
          </div>
          <div *ngFor="let data of cardsData">
            <div
              class="flex flex-col border p-2 hover:shadow-2xl transition transform active:scale-70 hover:scale-102
                justify-between content relative cursor-pointer flex flex-wrap gap-2 p-1 bg-white w-full md:w-72 h-full">
              <div style="font-size: x-small;" class="w-full h-min bg-gray-700 relative disc">
                <span class="rounded-r px-1  top-0 left-1  absolute font-semibold bg-primary text-white mr-2"
                  *ngIf="data.unit_price > data.discounted_price"> {{ getDiscountPercentage(data.unit_price,
                  data.discounted_price) }}% off</span>
                <div class=" rating  rounded-full  
                  absolute px-1 top-0 right-1 flex flex-row justify-end">
                  <div class="flex flex-row gap-1">
                    <span class="text-yellow-500"> ⭐️ </span>
                    <p class="font-bold">{{ data.rating || 0 }}</p>
                  </div>
                  <span class="font-bold ml-1">({{ data.review_count || 0 }})</span>
                </div>

                <img class="object-cover  align-middle self-center mx-auto" [src]="data.main_image" alt="Product image"
                  (click)="redirectToProduct(data.slug)">
              </div>
              <div class="text text-center w-full flex-col gap-2 justify-between">
                <p class="mx-auto text-wrap text-xs font-bold px-5 text-black shiny-text  w-full "
                  (click)="redirectToProduct(data.slug)">
                  {{data.title}}
                </p>
                <div class="flex flex-row truncate justify-center gap-2 max-w-[300px] mx-auto text-xs text-black">
                  <p *ngFor="let t of parseJSON(data.tags)" class="">
                    {{ t }}
                  </p>
                </div>

                <p class=" antialiased font-bold text-sm flex flex-wrap gap-1 justify-center w-full shiny-text">
                  <span class="rupee text-black"></span>
                  <span class="text-black">{{data.discounted_price}}.00 </span> <span
                    class="line-through  text-red-500"> <span class="rupee"></span>
                    {{data.unit_price}}.00</span>

                </p>
                <div class="mt-2 flex text-nowrap justify-evenly gap-2 text-xs w-full h-min">
                  <button [disabled]="data.quantity && data.quantity < 1" class="border-2 btn w-full py-2 px-4 rounded"
                    (click)="addProductToCart(data)">
                    <i class="pi pi-cart-plus "> </i>
                  </button>
                  <button [disabled]="data.quantity && data.quantity < 1" class="w-full btn-primary py-2 px-4 rounded-2"
                    (click)="buyNow(data)">Buy
                    Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>